/* ============================================================
 * indexed-tab-nav.js
 * ------------------------------------------------------------
 * [수정 규칙] 이 파일을 수정하는 사람·AI 모두 지킬 것
 *   1. 하위 호환: 기존 동작·기본값은 바꾸지 않는다. 새 동작은 data-* 옵션으로 추가
 *      (속성 없음 = 기존 동작 / 속성만 = 기본값 / 값 = 그 값)
 *      기본 동작을 꼭 바꿔야 하면 아래 수정 이력에 "⚠ 기본 동작 변경"으로 표시
 *   2. 수정 이력: 아래에 "수정: YYYY-MM-DD 내용 — 기존 동작 영향" 한 줄 추가
 *   3. 옵션을 추가하면 아래 사용법 주석(옵션 설명 + 예시 마크업)도 같이 갱신
 *   4. 코드 스타일은 이 파일 기존 방식 유지 (IIFE, 화살표 함수, 인스턴스 스코프 조회, 의도 주석)
 *   5. 수정 후 node --check 로 문법 확인, 수정 내용은 소희에게 공유
 * ------------------------------------------------------------
 * 최초 작성일: 2026-08-31
 * 수정: 2026-10-16 분리 모드(href 패널) + 외부 점프 링크(data-tab-jump) 추가 — 기존 동작 변경 없음
 * 수정: 2026-10-16 첫 패널 도달 전 활성 탭 없음(기본) + data-init-active 옵션, iOS 스크롤 목표 올림(Math.ceil)
 *       — 카페24 tabnav 스니펫(2026-10-12)과 동작 통일. ⚠ 기본값 변경: 처음부터 첫 탭을 켜려면 data-init-active
 * 수정: 2026-10-16 고정 시 너비 옵션 data-fixed-width (본문 너비 / 화면 꽉 참) — 속성 없으면 기존처럼 페이지 CSS가 담당
 * 수정: 2026-10-19 스와이프 모드 PC 드래그 고스트 방지(dragstart 차단) + 버튼 텍스트 선택 방지 — 기존 동작 변경 없음
 * 수정: 2026-10-22 탭 콘텐츠 종료 후 고정 유지 옵션 data-fixed-stay 추가 — 속성 없으면 기존처럼 마지막 패널 지나면 고정 해제
 * 수정: 2026-10-22 마지막 패널 하단이 기준선을 지나면 활성 탭 전부 해제 (data-fixed-stay 여부와 무관)
 *       — ⚠ 기본 동작 변경(옵션 없이 전 페이지 적용). 탭 바는 이미 고정 해제된 시점이라 화면 영향은 거의 없음
 * 수정: 2026-10-22 고정 순간 덜컹거림 수정 — 직전 프레임 스크롤 이동량만큼 미리 판정해 한 프레임 일찍 고정
 *       (iOS는 스크롤을 JS보다 먼저 그려서 탭 바가 헤더 선을 약 3px 지나쳤다가 되돌아오던 문제, TW 본행사 디자인 QA)
 *       — ⚠ 기본 동작 변경(옵션 없이 전 페이지 적용). 고정 시점이 아래로 스크롤 중일 때만 최대 30px 이내로 앞당겨짐
 * 수정: 2026-10-22 위로 스크롤해 고정 풀릴 때도 같은 방식으로 한 프레임 일찍 해제
 *       (탭 바가 늦게 따라오며 원래 자리가 잠깐 비어 보이던 문제) — ⚠ 기본 동작 변경, 최대 30px 이내
 * 수정: 2026-10-22 탭 구간 끝 지정 옵션 data-panel-end 추가 — 속성 없으면 기존처럼 마지막 패널 하단이 끝
 *       (마지막 탭 콘텐츠 뒤에 테마 섹션(FCS 등)이 이어져 패널로 감쌀 수 없을 때, TW 2610 본행사 07)
 * 수정: 2026-10-23 data-fixed-width="full" 표시 방식 변경 — 배경만 화면 끝까지, 탭 버튼은 본문 너비 안에서만 보임
 *       (기존: 버튼이 본문 바깥까지 이어져 보임. 디자인 2파트 결정으로 3리전 통일) — ⚠ 기본 동작 변경("full" 쓰는 페이지 전부)
 * 수정: 2026-10-23 탭 클릭 이동 시 헤더 높이를 "상단에 붙었을 때" 기준으로 계산 — 최상단 첫 클릭이 띠배너 높이만큼 덜 올라가던 문제 수정
 *       (띠배너 없는 테마·두 번째 클릭부터는 값이 같아 기존 동작과 동일)
 *
 * 통이미지 탭 네비게이션 (클릭 스크롤 + 상단 고정 + 스크롤스파이)
 *
 *   · 버튼 클릭 → 같은 순번(index) 패널로 부드럽게 스크롤
 *   · 스크롤 시 탭바가 헤더 하단에 고정(is-fixed), placeholder로 점프 방지
 *   · 스크롤스파이(현재 위치 패널에 맞는 버튼 자동 active)
 *   · 마지막 패널 구간을 지나면 고정 해제 → 다음 섹션을 덮지 않음 (data-fixed-stay 로 유지 가능)
 *
 * [스코프] 최상위 .indexed-tab-nav 컨테이너 단위로 동작.
 *   컨테이너 "안에서만" .tab-bar / .tab-panel 을 조회하므로,
 *   안쪽 클래스는 범용 이름 그대로여도 다른 영역과 충돌하지 않음.
 *   한 페이지에 .indexed-tab-nav 가 여러 개면 각각 독립 초기화됨(멀티 인스턴스).
 *
 * [매칭 규칙] 버튼과 패널은 "DOM 등장 순서(index)"로 자동 연결.
 *   버튼 N번째 ↔ 패널 N번째. 개수·순서만 맞추면 됨. data-* 속성 불필요.
 *
 * [두 가지 모드]
 *   1) 기본 모드: 버튼이 부모 폭을 균등 분할(flex). 개수 많으면 버튼이 좁아짐.
 *   2) 스와이프 모드: 컨테이너에 data-swipe 부여 시 활성화.
 *      - 버튼 폭 고정, 넘치면 좌우 스와이프(Swiper 8)
 *      - 스크롤스파이로 활성화된 버튼이 자동으로 가운데 정렬(slideTo)
 *      - Swiper 마크업(.swiper-wrapper/.swiper-slide)은 JS가 런타임에 자동 래핑
 *        → 팀원은 기본 모드와 동일한 마크업 + data-swipe 만 추가하면 됨
 *      - Swiper 전역(window.Swiper)이 없으면 기본 모드로 폴백
 *      - 버튼 너비: data-tab-width(px) 로 지정 가능. 없으면 CSS 값 사용.
 *        예) <div class="indexed-tab-nav" data-swipe data-tab-width="80">
 *
 * [필요 마크업]
 *   .indexed-tab-nav (스와이프 모드는 여기에 data-swipe 속성 추가)
 *     .tab-bar-area > .tab-bar > .tab-bar__btn(a) * N
 *     .tab-panel * N (버튼 개수와 동일)
 *   버튼·패널 모두 .indexed-tab-nav 자식으로 들어가야 스코프가 잡힘.
 *   (첫 버튼 .is-active 는 선택 — 스크롤스파이가 초기화 때 상태를 다시 맞춤), 통이미지 버튼은 .tab-bar__img--off / --on 이미지 쌍.
 *   (자세한 마크업·CSS 템플릿은 팀 공지 가이드 참고)
 *
 * [분리 모드] (2026-10-16 추가) 컨테이너 안에 .tab-panel 이 하나도 없으면 자동 전환.
 *   각 버튼의 href="#id" 가 가리키는 요소를 패널로 사용 → 탭 바와 섹션이
 *   서로 다른 Shopify 섹션(Custom Liquid)으로 나뉘어 있어도 동작.
 *   예) <a class="tab-bar__btn" href="#tabCon3"> ↔ <div id="tabCon3">
 *   패널은 매번 id로 다시 찾음 (커스터마이저 재렌더로 섹션 DOM이 바뀌어도 대응).
 *   ※ 컨테이너 안에 .tab-panel 이 있으면 기존(인덱스 매칭) 방식 그대로.
 *
 * [외부 점프 링크] (2026-10-16 추가) 페이지 어디에 있든 data-tab-jump 링크를 누르면
 *   같은 #id 를 가리키는 탭 버튼을 누른 것과 똑같이 이동(헤더+탭바 높이 보정, 탭 활성화).
 *   · 속성만:  <a href="#tabCon3" data-tab-jump>        → href 의 #id 로
 *   · 값 지정: <a href="..." data-tab-jump="#tabCon3">  → 값의 #id 로
 *   매칭되는 탭이 없으면 브라우저 기본 앵커 이동. (탭 버튼에 href="#id" 가 있어야 매칭됨)
 *
 * [고정 시 너비] (2026-10-16 추가) 탭바가 상단 고정(is-fixed)됐을 때의 가로 범위를 JS가 맞춤.
 *   · data-fixed-width          속성만 = 본문 너비. 고정 전 자리(.tab-bar-area)와 같은 left·width
 *   · data-fixed-width="full"   배경만 화면 가로 꽉 참. 탭 버튼은 본문 너비 안에서만 보이고 바깥으로 넘친 탭은 잘림
 *                               (탭바는 본문 자리에 두고, 배경색을 box-shadow로 좌우 확장 + clip-path로 위아래 넘침 차단)
 *   · 속성 없음                 기존 동작 (고정 시 위치·너비는 페이지 CSS가 담당)
 *   ※ 옵션을 쓰면 left·width·padding·transform 을 인라인으로 넣으므로, 페이지 CSS의 .tab-bar.is-fixed 엔
 *     position:fixed 와 z-index 만 두면 됨 (left:50% / translateX / max-width 등 위치 지정은 빼기).
 *     본문 최대 너비(500px 등)를 하드코딩하지 않고 실제 본문 자리를 재서 맞추므로 페이지마다 그대로 동작.
 *
 * [종료 후 고정 유지] (2026-10-22 추가) 마지막 패널을 지난 뒤에도 탭바를 계속 고정할지 제어.
 *   · 속성 없음          기존 동작. 마지막 패널 하단이 (헤더+탭바) 위로 올라가면 고정 해제 → 다음 섹션 안 덮음
 *   · data-fixed-stay    마지막 패널을 지나도 고정 유지. 탭바 자리(.tab-bar-area) 위로 다시 올라갈 때만 해제
 *   · 활성 탭: 두 경우 모두 마지막 패널 하단이 기준선(헤더+탭바)을 지나면 활성 전부 해제
 *   예) <div class="indexed-tab-nav" data-swipe data-fixed-stay>
 *   ※ 유지 중엔 탭바가 아래 섹션 위에 겹쳐 보이므로, 탭바 배경·z-index 가 다른 요소와 어울리는지 확인.
 *
 * [탭 구간 끝 지정] (2026-10-22 추가) 고정 해제·활성 해제 기준이 되는 "탭 구간 끝" 위치를 바꿈.
 *   · 속성 없음                       기존 동작. 마지막 패널 하단 = 탭 구간 끝
 *   · data-panel-end="#선택자"        그 요소의 상단 = 탭 구간 끝 (요소가 없으면 기존 동작)
 *   마지막 탭 콘텐츠 뒤에 패널로 감쌀 수 없는 섹션(Shopify FCS 등)이 이어질 때, 그 다음 섹션 맨 위에
 *   빈 요소(예: <div id="tabConEnd"></div>)를 두고 지정 → 그 섹션들을 보는 동안 고정·마지막 탭 활성 유지
 *   예) <div class="indexed-tab-nav" data-swipe data-panel-end="#tabConEnd">
 *
 * [초기 활성] (2026-10-16 변경)
 *   기본: 첫 패널이 기준선(헤더+탭바 하단+10px)에 닿기 전엔 활성 탭 없음 (인트로 구간에서 탭이 켜져 보이지 않게)
 *   data-init-active 속성만 있으면 첫 패널 도달 전에도 첫 번째 탭 활성 (2026-10-16 이전 동작)
 *   예) <div class="indexed-tab-nav" data-swipe data-init-active>
 *
 * [의존성] 기본 모드: 없음(vanilla). 스와이프 모드: Swiper 8 (테마에 이미 로드됨).
 *
 * KR(Cafe24) 원본에서 스킨 헤더 연동 로직을 제거한 해외(Shopify) 버전.
 * 헤더 높이는 <header data-section-type="header"> 요소에서 직접 측정.
 * ============================================================ */
(function () {
	"use strict";

	/* 고정 헤더 하단선: sticky 헤더 요소의 현재 화면상 bottom 값을 직접 측정.
	 * Stiletto 헤더는 <header data-section-type="header"> 요소.
	 * getBoundingClientRect().bottom → 헤더가 화면에 떠 있으면 양수(그 높이),
	 * 스크롤로 헤더가 사라지면 음수 → 0으로 클램프.
	 * 헤더 없는 페이지에선 요소가 없어 0 → 안전.
	 * (헤더는 페이지 전역 1개이므로 인스턴스 공통으로 한 번만 조회) */
	const header = document.querySelector('header[data-section-type="header"]');
	const getHeaderHeight = () => {
		if (!header) return 0;
		const bottom = header.getBoundingClientRect().bottom;
		return bottom > 0 ? bottom : 0;
	};

	/* 이동 목표 계산용: 헤더가 상단에 붙었을 때의 하단선 (= 래퍼 sticky top + 높이).
	 * 최상단에서는 헤더 위 띠배너(announcement bar)만큼 현재 하단선이 더 아래에 있어서,
	 * 현재값으로 계산하면 도착 시 띠배너 높이만큼 덜 올라감 (테마 PC 띠배너 45px에서 확인).
	 * 띠배너 고정 설정·PC 음수 top도 sticky top 값에 이미 반영돼 있어 별도 처리 불필요.
	 * sticky가 아닌 테마는 기존 동작(현재 하단선) 유지 */
	const headerWrap = header ? header.closest(".shopify-section") : null;
	const getStickyHeaderBottom = () => {
		if (!headerWrap) return getHeaderHeight();
		const cs = getComputedStyle(headerWrap);
		if (cs.position !== "sticky") return getHeaderHeight();
		const bottom = (parseFloat(cs.top) || 0) + headerWrap.offsetHeight;
		return bottom > 0 ? bottom : 0;
	};

	/* "#id" → "id" (href·data-tab-jump 값 공통). 그 외 형식은 "" */
	const toId = (value) => {
		const raw = (value || "").trim();
		if (raw.charAt(0) !== "#" || raw.length < 2) return "";
		try {
			return decodeURIComponent(raw.slice(1));
		} catch (err) {
			return raw.slice(1);
		}
	};

	/* 초기화된 인스턴스 목록 (외부 점프 링크가 대상 탭을 찾을 때 사용) */
	const instances = [];

	/* 외부 점프 링크: [data-tab-jump] 클릭 → 같은 #id 를 가리키는 탭으로 이동.
	 * document 위임 1회 등록 → 나중에 삽입된 링크도 동작. 매칭 없으면 기본 앵커 이동 */
	document.addEventListener("click", (e) => {
		const link = e.target.closest("[data-tab-jump]");
		if (!link) return;
		const id = toId(link.getAttribute("data-tab-jump") || link.getAttribute("href"));
		if (!id) return;

		for (const inst of instances) {
			if (!inst.root.isConnected) continue; // 커스터마이저 재렌더로 사라진 인스턴스 제외
			const index = inst.panelIds.indexOf(id);
			if (index < 0) continue;
			e.preventDefault();
			inst.jumpTo(index);
			return;
		}
	});

	/* 컨테이너(root) 1개를 받아 그 안에서만 탭 네비게이션을 초기화 */
	const initTabNav = (root) => {
		if (root.dataset.tabNavReady) return; // 중복 초기화 방지
		const area = root.querySelector(".tab-bar-area");
		const bar = root.querySelector(".tab-bar");
		if (!area || !bar) return;

		const btns = [...root.querySelectorAll(".tab-bar__btn")];
		if (btns.length === 0) return;

		/* 패널 찾기
		 * - 기본: 컨테이너 안의 .tab-panel (DOM 순서로 버튼과 매칭)
		 * - 분리 모드: 컨테이너 안에 .tab-panel 이 없으면 버튼 href="#id" 대상 (매번 id로 다시 찾음) */
		const innerPanels = [...root.querySelectorAll(".tab-panel")];
		const isLinked = innerPanels.length === 0;
		const panelIds = btns.map((btn) => toId(btn.getAttribute("href")));
		const getPanel = (index) => {
			if (!isLinked) return innerPanels[index] || null;
			return panelIds[index] ? document.getElementById(panelIds[index]) : null;
		};
		const getPanels = () => (isLinked ? btns.map((_, i) => getPanel(i)) : innerPanels);
		const getLastPanel = () => {
			const list = getPanels();
			for (let i = list.length - 1; i >= 0; i--) if (list[i]) return list[i];
			return null;
		};
		if (!getLastPanel()) return;

		root.dataset.tabNavReady = "1";

		/* ===== 스와이프 모드 판정 + Swiper 초기화 =====
		 * data-swipe 가 있고 window.Swiper 가 로드돼 있을 때만 스와이프.
		 * 없으면 기본(flex) 모드로 자연 폴백. */
		const wantSwipe = root.hasAttribute("data-swipe");
		let swiper = null;

		if (wantSwipe && typeof window.Swiper === "function") {
			/* 버튼 너비: data-tab-width(px) 로 지정 가능. 없으면 CSS 값 사용.
			 * 예) <div class="indexed-tab-nav" data-swipe data-tab-width="80"> */
			const tabWidth = parseFloat(root.dataset.tabWidth);
			const hasTabWidth = Number.isFinite(tabWidth) && tabWidth > 0;

			/* Swiper 8 은 .swiper > .swiper-wrapper > .swiper-slide 구조 필요.
			 * 팀원 마크업(.tab-bar > .tab-bar__btn)을 런타임에 그 구조로 래핑. */
			const wrapper = document.createElement("div");
			wrapper.className = "swiper-wrapper";
			btns.forEach((btn) => {
				btn.classList.add("swiper-slide");
				/* flex 리셋: 기본 모드 CSS(.tab-bar__btn{flex:1})가 swiper의 flex-shrink:0 을
				 * 덮어써 슬라이드가 찌그러지는 것을 방지. !important 로 확정. */
				btn.style.setProperty("flex", "0 0 auto", "important");
				/* 드래그 중 버튼 텍스트가 선택(파랗게)되지 않도록 */
				btn.style.setProperty("-webkit-user-select", "none");
				btn.style.setProperty("user-select", "none");
				if (hasTabWidth) btn.style.setProperty("width", tabWidth + "px", "important"); // 버튼 고정폭 적용(!important 로 테마 CSS 우선)
				wrapper.appendChild(btn); // btn 을 wrapper 로 이동
			});
			bar.appendChild(wrapper);
			bar.classList.add("swiper");

			/* PC 드래그 고스트 방지: a 기본 드래그(링크 끌기)가 시작되면 고스트 이미지가 뜨고
			 * 스와이프가 끊김 → 탭바 안에서 시작된 dragstart 는 모두 차단 (모든 브라우저 대응) */
			bar.addEventListener("dragstart", (event) => event.preventDefault());

			swiper = new window.Swiper(bar, {
				slidesPerView: "auto",
				centeredSlides: true, // 활성 탭을 가운데로
				centeredSlidesBounds: true, // 단, 양 끝(첫/마지막 탭)에선 여백 없이 붙임
				slideToClickedSlide: false, // 클릭 이동은 우리 로직이 담당
			});
		}

		/* 초기 활성: 속성만 있으면 첫 패널 도달 전에도 첫 탭 활성 (기본: 활성 없음) */
		const initActive = root.hasAttribute("data-init-active");

		/* 종료 후 고정 유지: 속성만 있으면 마지막 패널을 지나도 is-fixed 유지 (기본: 해제) */
		const fixedStay = root.hasAttribute("data-fixed-stay");

		/* 탭 구간 끝(화면 기준 y): data-panel-end 요소 상단 > 마지막 패널 하단 > 없음(-Infinity = 이미 끝)
		 * 고정 해제·활성 해제가 같은 기준을 쓰도록 한 곳에서 계산 (요소는 매번 다시 찾음 → 섹션 재렌더 대응) */
		const panelEndSelector = root.dataset.panelEnd || "";
		const getContentEnd = () => {
			if (panelEndSelector) {
				let endEl = null;
				try {
					endEl = document.querySelector(panelEndSelector);
				} catch (err) {
					endEl = null; // 잘못된 선택자면 기존 동작으로
				}
				if (endEl) return endEl.getBoundingClientRect().top;
			}
			const lastPanel = getLastPanel();
			return lastPanel ? lastPanel.getBoundingClientRect().bottom : -Infinity;
		};

		/* 탭 클릭 스크롤 중에는 스크롤스파이 잠금
		 * (이동 중 중간 패널들이 스쳐 지나가며 active가 깜빡이는 것 방지) */
		let isClickScrolling = false;
		let clickedIndex = -1;

		/* 현재 버튼 active 갱신 + (스와이프 모드면) 활성 버튼 가운데 정렬 */
		const setActive = (index) => {
			btns.forEach((btn, i) => btn.classList.toggle("is-active", i === index));
			if (swiper) swiper.slideTo(index); // 활성 버튼을 가운데로 이동
		};

		/* 활성 전부 해제 (첫 패널 도달 전 구간) — 스와이프 위치는 그대로 둠 */
		const clearActive = () => btns.forEach((btn) => btn.classList.remove("is-active"));

		let rafId = null; // smooth 도달 감시 rAF 핸들
		const releaseLock = () => {
			if (!isClickScrolling) return;
			isClickScrolling = false;
			if (rafId) {
				cancelAnimationFrame(rafId);
				rafId = null;
			}
			if (clickedIndex >= 0) {
				setActive(clickedIndex);
				clickedIndex = -1;
			}
		};

		/* 클릭 직후 짧은 유예: smooth 스크롤 잔여 이벤트를 사용자 스크롤로 오인해
		 * 가짜 해제되는 것을 방지 */
		let clickScrollAt = 0;
		const USER_SCROLL_GUARD = 400; // ms
		const releaseByUser = () => {
			if (Date.now() - clickScrollAt < USER_SCROLL_GUARD) return;
			releaseLock();
		};

		/* smooth 스크롤 목표 도달 감시 (시간이 아닌 위치 도달로 판정 → 기기/거리 무관) */
		const ARRIVE_EPS = 2; // 도달 판정 허용 오차(px)
		const ARRIVE_TIMEOUT = 1000; // 안전장치: 초과 시 강제 해제(ms)

		const waitArrival = (targetTop) => {
			if (rafId) cancelAnimationFrame(rafId);
			const startedAt = Date.now();
			const maxTop = document.documentElement.scrollHeight - window.innerHeight;
			/* 문서 끝을 넘는 좌표 요청 시 실제 도달값은 maxTop에서 멈추므로 클램프 */
			const goal = Math.max(0, Math.min(targetTop, maxTop));

			const step = () => {
				if (!isClickScrolling) {
					rafId = null;
					return;
				}
				const reached = Math.abs(window.pageYOffset - goal) <= ARRIVE_EPS;
				const timedOut = Date.now() - startedAt > ARRIVE_TIMEOUT;
				if (reached || timedOut) {
					rafId = null;
					releaseLock();
					return;
				}
				rafId = requestAnimationFrame(step);
			};
			rafId = requestAnimationFrame(step);
		};

		/* 대응 패널로 스크롤 (offset = 상단에 붙은 헤더 높이 + 고정 탭바 높이) */
		const jumpTo = (index) => {
			const panel = getPanel(index);
			if (!panel) return;

			isClickScrolling = true;
			clickScrollAt = Date.now();
			clickedIndex = index;
			setActive(index);

			const offset = getStickyHeaderBottom() + bar.offsetHeight;
			/* iOS는 스크롤 위치를 정수로 내림 → 소수 목표면 1px 못 미쳐 고정·활성 경계를 못 넘음. 올림으로 보정 */
			const top = Math.ceil(panel.getBoundingClientRect().top + window.pageYOffset - offset);

			window.scrollTo({ top, behavior: "smooth" });
			waitArrival(top);
		};

		/* 버튼 클릭 → 대응 패널로 */
		btns.forEach((btn, index) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				jumpTo(index);
			});
		});

		/* 외부 점프 링크(data-tab-jump)용 등록 */
		instances.push({ root, panelIds, jumpTo });

		/* 사용자가 직접 스크롤(휠/터치)하면 락 즉시 해제 — 사용자 의도 우선 */
		window.addEventListener("wheel", releaseByUser, { passive: true });
		window.addEventListener("touchmove", releaseByUser, { passive: true });

		/* 고정 전 본래 탭바 높이(회전/리사이즈 대응 위해 비고정 상태에서 측정) */
		let barHeight = bar.offsetHeight;

		/* 고정 시 너비 옵션: "" = 본문 너비, "full" = 화면 꽉 참, null = 미사용(페이지 CSS 담당) */
		const fixedWidth = root.hasAttribute("data-fixed-width") ? (root.getAttribute("data-fixed-width") || "").trim() : null;
		const FIXED_PROPS = ["left", "right", "width", "max-width", "transform", "box-shadow", "clip-path"];

		/* 고정 상태의 가로 범위를 본문 자리(area) 기준으로 맞춤 */
		const applyFixedWidth = () => {
			if (fixedWidth === null) return;
			const rect = area.getBoundingClientRect();
			bar.style.setProperty("transform", "none", "important"); // 페이지 CSS의 가운데 정렬 transform 무력화
			bar.style.setProperty("max-width", "none", "important");
			bar.style.setProperty("right", "auto", "important");
			bar.style.setProperty("left", rect.left + "px", "important");
			bar.style.setProperty("width", rect.width + "px", "important");

			/* full: 탭바(버튼 영역)는 본문 자리 그대로 두고 배경색만 화면 끝까지 칠함
			 * → 넘친 탭 버튼은 탭바 overflow에서 잘리고, box-shadow는 잘리지 않아 좌우로 퍼짐 / clip-path로 위아래 그림자 차단 */
			if (fixedWidth === "full") {
				const bg = getComputedStyle(bar).backgroundColor;
				if (bg && bg !== "transparent" && bg !== "rgba(0, 0, 0, 0)") {
					bar.style.setProperty("box-shadow", `0 0 0 100vmax ${bg}`, "important");
					bar.style.setProperty("clip-path", "inset(0 -100vmax)", "important");
				}
			}
		};

		const clearFixedWidth = () => {
			if (fixedWidth === null) return;
			FIXED_PROPS.forEach((prop) => bar.style.removeProperty(prop));
		};

		/* 탭바 fixed 전환 + placeholder 높이 유지 */
		/* 고정·해제 미리 판정: iOS는 스크롤을 JS보다 먼저 그려서, 판정한 프레임엔 탭 바 자리가 이미 선을 지나 있음
		 * → 직전 프레임 대비 이동량만큼 앞당겨 판정 (앵커 점프처럼 큰 이동은 MAX_FIX_LEAD로 제한)
		 *   아래로 스크롤: 한 프레임 일찍 고정 / 위로 스크롤: 한 프레임 일찍 해제 */
		const MAX_FIX_LEAD = 30; // 미리 판정 최대 거리(px)
		let prevAreaTop = null;

		const updateBarFixed = () => {
			const headerHeight = getHeaderHeight();
			const isFixed = bar.classList.contains("is-fixed");
			if (!isFixed) barHeight = bar.offsetHeight;
			const areaTop = area.getBoundingClientRect().top;
			const fixLead = prevAreaTop === null ? 0 : Math.min(Math.max(prevAreaTop - areaTop, -MAX_FIX_LEAD), MAX_FIX_LEAD); // +아래 / -위 스크롤
			prevAreaTop = areaTop;

			/* 상단 경계: 탭바 영역 상단이 헤더 하단선에 닿음 = 고정 시작선
			 * 하단 경계: 탭 구간 끝(마지막 패널 하단 또는 data-panel-end)이 (헤더+탭바) 위로 올라감 = 패널 구간 끝
			 *   → 기본: 이 지점을 지나면 탭바 역할이 끝났으므로 고정 해제(다음 섹션 안 덮음)
			 *   → data-fixed-stay: 하단 경계 무시 → 페이지 끝까지 고정 유지 */
			const passedTop = areaTop - fixLead <= headerHeight; // 다음 프레임 위치 기준: 넘을 예정이면 미리 고정, 벗어날 예정이면 미리 해제
			const passedBottom = !fixedStay && getContentEnd() <= headerHeight + barHeight;

			if (passedTop && !passedBottom) {
				if (!isFixed) {
					area.style.height = barHeight + "px"; // 자리 유지(점프 방지)
					bar.classList.add("is-fixed");
				}
				bar.style.top = headerHeight + "px"; // 헤더 바로 아래에 붙임
				applyFixedWidth(); // (옵션) 가로 범위 맞춤 — 리사이즈 시에도 매번 재계산
			} else if (isFixed) {
				bar.classList.remove("is-fixed");
				bar.style.top = "";
				area.style.height = "";
				clearFixedWidth();
			}
		};

		/* 스크롤스파이: 임계선(헤더+탭바 하단) 넘은 마지막 패널을 active
		 * 탭 구간 끝이 (헤더+탭바) 위로 올라가면 = 탭 콘텐츠 종료 → 활성 전부 해제
		 * (고정 해제 판정과 같은 기준선. data-fixed-stay 여부와 무관하게 항상 적용) */
		const updateActiveTab = () => {
			if (isClickScrolling) return;
			const headerHeight = getHeaderHeight();
			if (getContentEnd() <= headerHeight + bar.offsetHeight) {
				clearActive();
				return;
			}
			const threshold = headerHeight + bar.offsetHeight + 10;
			let currentIndex = initActive ? 0 : -1; // 기본: 첫 패널이 기준선에 닿기 전엔 활성 없음
			getPanels().forEach((panel, i) => {
				if (panel && panel.getBoundingClientRect().top <= threshold) currentIndex = i;
			});
			if (currentIndex < 0) {
				clearActive();
				return;
			}
			setActive(currentIndex);
		};

		/* 스크롤/리사이즈 (rAF 최적화) */
		let ticking = false;
		const onScroll = () => {
			if (ticking) return;
			requestAnimationFrame(() => {
				updateBarFixed();
				updateActiveTab();
				ticking = false;
			});
			ticking = true;
		};

		window.addEventListener("scroll", onScroll, { passive: true });
		window.addEventListener("resize", onScroll, { passive: true });
		updateBarFixed(); // 초기 1회
		updateActiveTab();
	};

	/* scope(document 또는 재렌더된 섹션) 안의 모든 .indexed-tab-nav 를 각각 초기화.
	 * scope 자신이 .indexed-tab-nav 인 경우(섹션 루트 = 컨테이너)도 포함. */
	const initAll = (scope) => {
		const roots = [...scope.querySelectorAll(".indexed-tab-nav")];
		if (scope.classList && scope.classList.contains("indexed-tab-nav")) {
			roots.unshift(scope);
		}
		roots.forEach(initTabNav);
	};

	/* 초기화 */
	const ready = (fn) => {
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", fn);
		} else {
			fn();
		}
	};

	ready(() => initAll(document)); // 최초 1회: 전체 문서
	/* 커스터마이저/섹션 재렌더 대응(팀 컨벤션):
	 * 블록을 다시 그릴 때 그 섹션(e.target) 안에서만 재초기화 */
	document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();